import {
    ADDRESS_VALIDATION,
    CLAIM_XPL_TOKENS,
    UNLOCK_XPL_TOKENS,
    WALLET_DEPOSIT,
    WALLET_MIGRATE,
    WALLET_SWAP_PRIORITY,
    WALLET_TOPUP_HISTORY,
    XPL_WALLET_DETAILS,
    XPL_COINS_CONVERSION_RATE,
    XPL_COINS_CONVERT,
    XPL_COINS_CONVERT_TO_XPL,
    XPL_COINS_BALANCE,
    COINS_XPL_CONVERSION_RATE,
    GAMEZ_BOOST_BALANCE,
    GAMEZ_BOOST_REGISTRATION_STATUS,
} from "./../../utils/network/ApiEndpoints"
//REDUX-TOOLKIT
import {
    setAddressValidation,
    setAddressValidationLoading,
    setAllAddresses,
    setAllNetworks,
    setAllTokens,
    setAssets,
    setClaimLoading,
    setGrowth,
    setMigrationHistory,
    setTopupHistory,
    setTransactionHistory,
    setUnlockLoading,
    setWallet,
    setWalletPrioritySetting,
    setWithdrawHistory,
    setXplWalletDetails,
    setCoinsBalance,
    setRegistrationStatus,
} from "./walletsSlice"
import { useDispatch } from "react-redux"
//UTILS
import {
    ALL_NETWORKS,
    ALL_TOKENS,
    POST_SWAP,
    POST_WITHDRAW,
    TRANSACTION_HISTORY,
    MIGRATION_HISTORY,
    WALLET_ASSETS,
    WALLET_GROWTH,
    WALLET_OVERVIEW,
    WITHDRAW_ADDRESS,
    WITHDRAW_HISTORY,
    WITHDRAW_PAYMENT_LINK,
    WALLET_TOKEN_PAIR,
} from "../../utils/network/ApiEndpoints"
import ApiRequest from "../../utils/network/ApiRequest"
import { errorNotify } from "../../utils/alerts"

export const useWalletActions = () => {
    const dispatch = useDispatch()

    const walletOverview = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: WALLET_OVERVIEW,
            })
            .then((response: any) => {
                dispatch(setWallet(response.data.data))
                return response
            })
            .catch((error: any) => error)
    }

    const walletAssets = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: WALLET_ASSETS,
            })
            .then((response: any) => {
                dispatch(setAssets(response.data.data))
                return response
            })
            .catch((error: any) => error)
    }

    const walletGrowth = async (params) => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: WALLET_GROWTH,
                params,
            })
            .then((response: any) => {
                dispatch(setGrowth(response.data.data))
                return response
            })
            .catch((error: any) => error)
    }

    const getWithdrawHistory = async (params, saveRedux = true) => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: WITHDRAW_HISTORY,
                params,
            })
            .then((response: any) => {
                if (saveRedux) dispatch(setWithdrawHistory(response.data.data))
                return response.data
            })
            .catch((error: any) => error)
    }

    const getTransactionHistory = async (params: any) => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: TRANSACTION_HISTORY,
                params,
            })
            .then((response: any) => {
                if (params.limit <= 10) {
                    dispatch(setTransactionHistory(response.data.data))
                }
                return response
            })
            .catch((error: any) => error)
    }

    const getMigrationHistory = async (params?: any) => {
        const req = params
            ? {
                  method: "GET",
                  url: MIGRATION_HISTORY,
                  params,
              }
            : {
                  method: "GET",
                  url: MIGRATION_HISTORY,
              }
        return await ApiRequest()
            .request(req)
            .then((response: any) => {
                dispatch(setMigrationHistory(response.data.data))
                return response
            })
            .catch((error: any) => error)
    }

    const getAllTokens = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: ALL_TOKENS,
            })
            .then((response: any) => {
                dispatch(setAllTokens(response.data.data))
                return response
            })
            .catch((error: any) => error)
    }

    const getAllNetworks = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: ALL_NETWORKS,
            })
            .then((response: any) => {
                dispatch(setAllNetworks(response.data.data))
                return response
            })
            .catch((error: any) => error)
    }

    const postWithdraw = async (data: {
        fromWallet: string
        toAddress: string
        amount: number
        network: string
        otp?: any
    }) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: POST_WITHDRAW,
                data: data,
            })
            .then((response: any) => {
                return response
            })
            .catch((error: any) => error)
    }

    const postSwap = async (data: {
        fromWallet: string
        toWallet: string
        amount: number
    }) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: POST_SWAP,
                data: data,
            })
            .then((response: any) => {
                return response
            })
            .catch((error: any) => error)
    }

    const swapPriority = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: WALLET_SWAP_PRIORITY,
            })
            .then((response: any) => {
                dispatch(setWalletPrioritySetting(response.data.data))
                return response
            })
            .catch((error: any) => error)
    }

    const getWithdrawAddresses = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: WITHDRAW_ADDRESS,
            })
            .then((response: any) => {
                dispatch(setAllAddresses(response.data.data))
                return response
            })
            .catch((error: any) => error)
    }

    const getWithdrawUnlockPaymentLink = async (params) => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: WITHDRAW_PAYMENT_LINK,
                params,
            })
            .then((response: any) => {
                return response.data
            })
            .catch((error: any) => {
                return error
            })
    }

    const getWalletTokenPair = async (swapFrom: string, swapTo: string) => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: WALLET_TOKEN_PAIR + "/" + swapFrom + "/" + swapTo,
            })
            .then((response: any) => response?.data?.data)
            .catch((error: any) => error)
    }

    const walletMigrate = async (data: any) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: WALLET_MIGRATE,
                data,
            })
            .then((response: any) => response)
            .catch((error: any) => error)
    }

    const walletDeposit = async (amount) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: WALLET_DEPOSIT,
                data: { amount: Number(amount) },
            })
            .then((response: any) => {
                return response?.data
            })
            .catch((error: any) => error)
    }

    const walletTopupHistory = async (filters) => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: WALLET_TOPUP_HISTORY,
                params: filters,
            })
            .then((response: any) => {
                dispatch(setTopupHistory(response?.data?.data))
                return response?.data
            })
            .catch((error: any) => error)
    }
    const getXPLWalletDetails = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: XPL_WALLET_DETAILS,
            })
            .then((response: any) => {
                dispatch(setXplWalletDetails(response?.data?.data))
                return response?.data
            })
            .catch((error: any) => error)
    }
    const unlockXplTokens = async () => {
        dispatch(setUnlockLoading(true))
        return await ApiRequest()
            .request({
                method: "POST",
                url: UNLOCK_XPL_TOKENS,
            })
            .then((response: any) => {
                dispatch(setUnlockLoading(false))
                return response?.data
            })
            .catch((error: any) => {
                dispatch(setUnlockLoading(false))
                errorNotify(error?.data?.message || "Something went wrong")
                return error?.data
            })
    }
    const claimXplTokens = async () => {
        dispatch(setClaimLoading(true))
        return await ApiRequest()
            .request({
                method: "POST",
                url: CLAIM_XPL_TOKENS,
            })
            .then((response: any) => {
                dispatch(setClaimLoading(false))
                return response?.data
            })
            .catch((error: any) => {
                dispatch(setClaimLoading(false))
                errorNotify(error?.data?.message || "Something went wrong")
                return error?.data
            })
    }

    const AddressValidation = async (data: any) => {
        dispatch(setAddressValidationLoading(true))
        return await ApiRequest()
            .request({
                method: "POST",
                url: ADDRESS_VALIDATION,
                data,
            })
            .then((response: any) => {
                // dispatch(setAddressValidation(response?.data))
                return response?.data
            })
            .catch((error: any) => {
                dispatch(setAddressValidationLoading(false))
                errorNotify(error?.data?.message || "Something went wrong")
                return error?.data
            })
            .finally(() => {
                dispatch(setAddressValidationLoading(false))
            })
    }

    const getXPLCoinsConversionRate = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: XPL_COINS_CONVERSION_RATE,
            })
            .then((response: any) => {
                return response?.data
            })
            .catch((error: any) => {
                return error?.data
            })
    }

    const convertXPLToCoins = async (data: { xplAmount: number }) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: XPL_COINS_CONVERT,
                data,
            })
            .then((response: any) => {
                return response?.data
            })
            .catch((error: any) => {
                return error?.data
            })
    }

    const convertCoinsToXpl = async (data: { coinsAmount: number }) => {
        return await ApiRequest()
            .request({
                method: "POST",
                url: XPL_COINS_CONVERT_TO_XPL,
                data,
            })
            .then((response: any) => {
                return response?.data
            })
            .catch((error: any) => {
                return error?.data
            })
    }

    const getXPLCoinsBalance = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: GAMEZ_BOOST_BALANCE,
            })
            .then((response: any) => {
                dispatch(setCoinsBalance(response?.data?.data))
                return response?.data
            })
            .catch((error: any) => {
                return error?.data
            })
    }

    const getCoinsToXplConversionRate = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: COINS_XPL_CONVERSION_RATE,
            })
            .then((response: any) => {
                return response?.data
            })
            .catch((error: any) => {
                return error?.data
            })
    }

    const getGamezBoostRegistrationStatus = async () => {
        return await ApiRequest()
            .request({
                method: "GET",
                url: GAMEZ_BOOST_REGISTRATION_STATUS,
            })
            .then((response: any) => {
                dispatch(setRegistrationStatus(response?.data?.data))
                return response?.data
            })
            .catch((error: any) => {
                return error?.data
            })
    }

    return {
        AddressValidation,
        walletOverview,
        walletAssets,
        walletGrowth,
        getWithdrawHistory,
        getAllTokens,
        getAllNetworks,
        postWithdraw,
        postSwap,
        swapPriority,
        getWithdrawAddresses,
        getWithdrawUnlockPaymentLink,
        getTransactionHistory,
        getMigrationHistory,
        getWalletTokenPair,
        walletMigrate,
        walletDeposit,
        walletTopupHistory,
        getXPLWalletDetails,
        unlockXplTokens,
        claimXplTokens,
        getXPLCoinsConversionRate,
        convertXPLToCoins,
        convertCoinsToXpl,
        getCoinsToXplConversionRate,
        getXPLCoinsBalance,
        getGamezBoostRegistrationStatus,
    }
}
